const einValidation = (ein) => {
  const einPattern = /^\d{2}-\d{7}$/;
  return einPattern.test(ein);
};

export default einValidation;
